<template>
  <el-tabs v-model="activeName" :class="{'supervisor-tabs': true, 'hide-tabs': isLockOnLiveAnalytics}" :before-leave="onBeforeLeave">
    <el-tab-pane label="Monitor" name="monitor">
      <SupervisorMonitor />
    </el-tab-pane>
    <el-tab-pane label="Settings" name="settings">
      <SupervisorSettings />
    </el-tab-pane>
    <el-tab-pane label="Live Analytics" name="live-analytics" v-if="isLiveAnalyticsEnabled">
      <SupervisorLiveAnalytics />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import SupervisorMonitor from '@/views/Supervisor/SupervisorMonitor';
import SupervisorSettings from '@/views/Supervisor/SupervisorSettings';
import SupervisorLiveAnalytics from '@/views/Supervisor/LiveAnalytics/index.vue';
import _ from 'lodash';

export default {
  components: {
    SupervisorMonitor,
    SupervisorSettings,
    SupervisorLiveAnalytics,
  },
  computed: {
    isLockOnLiveAnalytics() {
      return this.$store.state.supervisor.isLockOnLiveAnalytics;
    },
    isLiveAnalyticsEnabled() {
      const enabled = _.get(this.$store.state.modules, "handover.liveChatLiveAnalytics.enabled", false);

      return enabled;
    },
  },
  data() {
    return {
      // Set the default tab to "monitor"
      activeName: 'monitor',
    };
  },
  methods: {
    lockOnAnalytics() {
      this.$store.commit('SET_NAVBAR_VISIBLE', false);
      this.$store.commit(
        'supervisor/SET_LOCK_ON_LIVE_ANALYTICS',
        true,
      );
    },
    onBeforeLeave(newTab, oldTab) {
      if (newTab === 'live-analytics' && oldTab !== 'live-analytics') {
        this.lockOnAnalytics();
      }
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
.supervisor-tabs {
  &.hide-tabs {
    ::v-deep .el-tabs__header {
      display: none;
    }
  }
}
</style>
